import { throwError } from 'rxjs';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from "../../core/services/index";

@Injectable({ providedIn: "root" })
export class coinsService {
  public currentCoins: any[] = [];
  public currentLimit: number = 6;
  public currentTotalCoins: number = 0;
  constructor(private _api: ApiService) {}

  save(data) {
    return this._api.post(`${"coins/save"}`, data).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getUserCoins(id) {
    return this._api.get(`${"coins/user/all/" + id}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getFeaturedCoins() {
    return this._api.get(`${"coins/featured"}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getCoinById(id) {
    return this._api.get(`${"coins/byId/" + id}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getCoinByIdWithAssessments(id) {
    return this._api.get(`${"coins/byId/included/assessments/" + id}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  updateCoinById(id, data) {
    return this._api.put(`${"coins/update/" + id}`, data).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  saveCoinReport(data) {
    return this._api.post(`${"coinReport/create"}`, data).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getAllCoins() {
    return this._api.get(`${"coins/all"}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  //   getMasterCollectionCoins(limit: number = 6) {
  //     let httpParams = new HttpParams();

  //     httpParams = httpParams.append("limit", limit);
  //     return this._api.get(`${"coins/master/collection?" + httpParams}`).pipe(
  //       map((res: any) => res),
  //       catchError((error: any) => throwError(() => error))
  //     );
  //   }

  getMasterCollectionCoins(limit: number = 6) {
    let httpParams = new HttpParams().append("limit", limit);
    return this._api.get(`coins/master/collection?${httpParams}`).pipe(
      map((res: any) => {
        this.currentCoins = res.data;
        this.currentLimit = limit;
        this.currentTotalCoins = res.totalCount || res.data?.length || 0;
        return res;
      }),
      catchError((error: any) => throwError(() => error))
    );
  }
  getAllIdentifyCoins(limit: number = 6) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append("limit", limit);
    return this._api.get(`${"coins/identify?" + httpParams}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getAllAssessCoins(limit: number = 6, userId: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append("limit", limit);
    httpParams = httpParams.append("userId", userId);
    return this._api.get(`${"coins/assess?" + httpParams}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getCoinIdentificationsById(coinId: string) {
    return this._api.get(`${"coins/identifications/byId/" + coinId}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getAllIARCoins(userId: string) {
    return this._api.get(`${"coins/iar/user-all/" + userId}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  getCoinsFilterOptions() {
    return this._api.get(`${"coins/filter-options"}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  // findSimilarGradedCoins(grade:number) {
  //     let httpParams = new HttpParams();
  //     httpParams = httpParams.append('grade', grade)
  //     return this._api.get(`${"coins/similar/grade?"+ httpParams}`)
  //         .pipe(
  //             map((res: any) => res),
  //             catchError((error: any) => throwError(() => error))
  //         );
  // }

  // findSimilarGradedCoins(coinId) {
  //     let httpParams = new HttpParams();
  //     httpParams = httpParams.append('coin_id', coinId)
  //     return this._api.get(`${"coins/similar/grade?"+ httpParams}`)
  //         .pipe(
  //             map((res: any) => res),
  //             catchError((error: any) => throwError(() => error))
  //         );
  // }

  // findSimilarGradedCoins(coinId, mean, nextType = null) {
  //     let httpParams = new HttpParams();
  //     httpParams = httpParams.append('coinId', coinId);
  //     httpParams = httpParams.append('mean', mean);
  //     httpParams = httpParams.append('nextType', nextType);
  //     return this._api.get(`${"coins/similar/grade?"+ httpParams}`)
  //         .pipe(
  //             map((res: any) => res),
  //             catchError((error: any) => throwError(() => error))
  //         );
  // }

  findSimilarGradedCoins(coinId: string, selectedGrade: string) {
    const params = new HttpParams()
      .set("coinId", coinId)
      .set("grade", selectedGrade.toString());

    return this._api.get(`${"coins/similar/grade?" + params}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  searchCoins(search: string, limit: number = 6, status: string = "all") {
    let httpParams = new HttpParams();
    httpParams = httpParams.append("searchText", search);
    httpParams = httpParams.append("limit", limit);
    httpParams = httpParams.append("status", status);
    return this._api.get(`${"coins/search?" + httpParams}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }

  //   advanceSearchCoins(params) {
  //     let httpParams = new HttpParams();
  //     for (let key in params) {
  //       if (params.hasOwnProperty(key)) {
  //         httpParams = httpParams.append(key, params[key]);
  //       }
  //     }
  //     return this._api.get(`${"coins/search?" + httpParams}`).pipe(
  //       map((res: any) => res),
  //       catchError((error: any) => throwError(() => error))
  //     );
  //   }
  advanceSearchCoins(params) {
    let httpParams = new HttpParams();
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.append(key, params[key]);
      }
    }
    return this._api.get(`coins/search?${httpParams}`).pipe(
      map((res: any) => {
        this.currentCoins = res.data;
        this.currentLimit = params.limit || 6;
        this.currentTotalCoins = res.totalCount || res.data?.length || 0;
        return res;
      }),
      catchError((error: any) => throwError(() => error))
    );
  }
  userAdvanceSearchCoins(params) {
    let httpParams = new HttpParams();
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.append(key, params[key]);
      }
    }
    return this._api.get(`${"coins/user-search?" + httpParams}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }
}
